var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 30,
    viewBox: "0 0 120 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    transform: "translate(0 1)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 17.9189L17.2109 15.0527L17.249 15.0303V11.2637L22.125 8.48535V17.9189Z",
    fill: "url(#paint0_linear_1810_3891)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 17.9199L13.9492 22.3809V16.9473L17.248 15.0312L22.125 17.9199Z",
    fill: "url(#paint1_linear_1810_3891)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9758 3.89182L13.9758 13.1469L22.0781 8.50391L13.9758 3.89182Z",
    fill: "#717171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9758 3.89182L13.9758 13.1469L22.0781 8.50391L13.9758 3.89182Z",
    fill: "#121212",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9688 22.3628L9.6416 24.7485L5.875 26.8198V8.50439L13.9688 3.97119V22.3628Z",
    fill: "url(#paint2_linear_1810_3891)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9754 3.8919L13.9754 13.1469L22.125 8.48633L13.9754 3.8919Z",
    fill: "url(#paint3_linear_1810_3891)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.975 3.8918L13.975 13.1469L5.87305 8.50488L13.975 3.8918Z",
    fill: "url(#paint4_linear_1810_3891)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.602 21V8.22H38.894C39.446 8.22 39.95 8.334 40.406 8.562C40.874 8.79 41.276 9.102 41.612 9.498C41.948 9.882 42.212 10.314 42.404 10.794C42.596 11.262 42.692 11.742 42.692 12.234C42.692 12.93 42.536 13.59 42.224 14.214C41.924 14.826 41.498 15.324 40.946 15.708C40.394 16.092 39.746 16.284 39.002 16.284H34.862V21H33.602ZM34.862 15.168H38.948C39.452 15.168 39.89 15.03 40.262 14.754C40.634 14.478 40.922 14.118 41.126 13.674C41.33 13.23 41.432 12.75 41.432 12.234C41.432 11.706 41.312 11.22 41.072 10.776C40.832 10.332 40.514 9.984 40.118 9.732C39.734 9.468 39.308 9.336 38.84 9.336H34.862V15.168ZM53.3853 19.884V21H44.7993V8.22H53.2233V9.336H46.0593V13.944H52.3053V15.006H46.0593V19.884H53.3853ZM55.768 21V8.22H61.168C61.72 8.22 62.224 8.334 62.68 8.562C63.136 8.79 63.532 9.102 63.868 9.498C64.216 9.882 64.48 10.314 64.66 10.794C64.852 11.262 64.948 11.742 64.948 12.234C64.948 12.846 64.828 13.422 64.588 13.962C64.36 14.502 64.03 14.958 63.598 15.33C63.178 15.702 62.68 15.948 62.104 16.068L65.236 21H63.814L60.808 16.284H57.028V21H55.768ZM57.028 15.168H61.204C61.708 15.168 62.146 15.03 62.518 14.754C62.89 14.478 63.178 14.118 63.382 13.674C63.586 13.218 63.688 12.738 63.688 12.234C63.688 11.718 63.568 11.244 63.328 10.812C63.1 10.368 62.788 10.014 62.392 9.75C62.008 9.474 61.576 9.336 61.096 9.336H57.028V15.168ZM76.4767 9.336H71.9227V21H70.6627V9.336H66.1087V8.22H76.4767V9.336ZM78.3911 21V8.22H79.6511V21H78.3911ZM84.1159 10.542V21H82.8559V8.22H83.8999L92.2879 18.876V8.238H93.5479V21H92.3779L84.1159 10.542ZM105.346 19.884V21H96.7602V8.22H105.184V9.336H98.0202V13.944H104.266V15.006H98.0202V19.884H105.346ZM112.631 21.09C111.731 21.09 110.915 20.91 110.183 20.55C109.451 20.19 108.821 19.704 108.293 19.092C107.765 18.468 107.357 17.772 107.069 17.004C106.781 16.224 106.637 15.426 106.637 14.61C106.637 13.758 106.787 12.948 107.087 12.18C107.387 11.4 107.807 10.71 108.347 10.11C108.899 9.498 109.541 9.018 110.273 8.67C111.005 8.31 111.797 8.13 112.649 8.13C113.549 8.13 114.365 8.316 115.097 8.688C115.829 9.06 116.453 9.558 116.969 10.182C117.497 10.806 117.905 11.502 118.193 12.27C118.481 13.038 118.625 13.824 118.625 14.628C118.625 15.48 118.475 16.296 118.175 17.076C117.875 17.844 117.455 18.534 116.915 19.146C116.375 19.746 115.739 20.22 115.007 20.568C114.275 20.916 113.483 21.09 112.631 21.09ZM107.897 14.61C107.897 15.306 108.011 15.978 108.239 16.626C108.467 17.262 108.791 17.832 109.211 18.336C109.631 18.828 110.129 19.224 110.705 19.524C111.293 19.812 111.935 19.956 112.631 19.956C113.363 19.956 114.017 19.806 114.593 19.506C115.181 19.194 115.679 18.786 116.087 18.282C116.507 17.766 116.825 17.19 117.041 16.554C117.257 15.918 117.365 15.27 117.365 14.61C117.365 13.914 117.251 13.248 117.023 12.612C116.795 11.976 116.465 11.406 116.033 10.902C115.613 10.398 115.115 10.002 114.539 9.714C113.963 9.426 113.327 9.282 112.631 9.282C111.911 9.282 111.257 9.432 110.669 9.732C110.093 10.032 109.595 10.44 109.175 10.956C108.767 11.46 108.449 12.03 108.221 12.666C108.005 13.302 107.897 13.95 107.897 14.61Z",
    fill: "#121212"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1810_3891",
    x1: 18.0265,
    y1: 10.8126,
    x2: 22.0309,
    y2: 17.8168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728113,
    stopColor: "#024FCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1810_3891",
    x1: 17.9428,
    y1: 15.3817,
    x2: 13.9137,
    y2: 22.3603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00091D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1810_3891",
    x1: 12.5042,
    y1: 12.9857,
    x2: 12.5749,
    y2: 26.8198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75ABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1810_3891",
    x1: 18.0341,
    y1: 10.8386,
    x2: 14.0115,
    y2: 3.87109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2876F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002983"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1810_3891",
    x1: 13.9387,
    y1: 3.87099,
    x2: 9.91602,
    y2: 10.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2876F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.c41cb1fd3f3a5e5687591527b2bffb83.svg";
export { ForwardRef as ReactComponent };